<template>
  <div v-if="pageData.count">
    <div class="page">
      <div class="fz-13">
        <span>第</span>
        <span class="ml-4 mr-4">{{pageData.page}}</span>
        <span>页</span>
      </div>
       <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="pageData.page"
        :page-size="pageData.offset"
        :page-sizes="pageSizes"
        layout="total,sizes,prev, pager, next, jumper"
        :total="pageData.count"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: "pagePagination",
  props: {
    pageData: {
      count: { default: 0 },
      page: { default: 1 },
      offset: { default: 10 },
    }
  },
  data () {
    return {
      pageSizes: [5, 10, 20, 30, 40],
    }
  },
  created() {
    // if (localStorage.getItem("pageSize")) {
    //   this.pageData.offset = parseInt(localStorage.getItem("pageSize"));
    //   this.handleSizeChange(this.pageData.offset);
    // }
  },
  mounted() {},
  methods: {
    // 分页改变
    handleSizeChange(pageSize) {
      this.pageData.page = 1;
      localStorage.setItem("pageSize", pageSize);
      this.$emit("pageChange", this.pageData.page, pageSize);
    },
    handleCurrentChange(page) {
      this.$emit("pageChange", page, this.pageData.offset);
    }
  }
}
</script>

<style scoped>
.page{
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px 0;
}
.mr-4 {
  margin-right: 4px;
}
.ml-4 {
  margin-left: 4px;
}
</style>